// Time-of-day options for the interview slot's Från/Till pickers.
//
// The slot is picked with the shared <Select> rather than a native <input type="time">, so
// it reads like every other field in these forms (Skede, Ägare) instead of showing each
// browser's own clock chrome. The cost is a fixed grid, so `withValue` keeps an off-grid
// time (booked before this grid existed, or written straight through the API) selectable
// rather than silently snapping it to the nearest half hour.
//
// The end time is cleared with the Select's own `isNullable` × button, not an empty option.

const START_HOUR = 7          // earliest interview slot offered
const END_HOUR   = 20         // latest; the grid's last option is 20:00
const STEP_MIN   = 30

const pad = (n) => String(n).padStart(2, '0')

const buildGrid = () => {
  const times = []
  for (let m = START_HOUR * 60; m <= END_HOUR * 60; m += STEP_MIN) {
    times.push(`${pad(Math.floor(m / 60))}:${pad(m % 60)}`)
  }
  return times
}

export const TIME_GRID = buildGrid()

const toOption = (value) => ({ value, label: value })

// The grid, plus `value` if it isn't on it, kept in chronological order.
const withValue = (times, value) => {
  if (!value || times.includes(value)) return times
  return [...times, value].sort()
}

export const startTimeOptions = (value) => withValue(TIME_GRID, value).map(toOption)

// Only times strictly after the chosen start can end an interview, so the invalid
// combination isn't offered in the first place (the form and the API still check — the API
// accepts requests this form never sends).
export const endTimeOptions = (start, value) =>
  withValue(TIME_GRID, value).filter(t => !start || t > start).map(toOption)
